import { render, staticRenderFns } from "./MakeCallWidget.vue?vue&type=template&id=8aa1e1d4&"
import script from "./MakeCallWidget.vue?vue&type=script&lang=js&"
export * from "./MakeCallWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports